import type { PreviewComponents, EditorPreviewCardGroup } from '@source-components-react/types';
import { cardGroups } from './base-components/editor-preview/card-groups';

let cachedPreviewComponents: PreviewComponents | undefined;

/**
 * Returns the preview card groups for drag and drop functionality.
 * This replaces the dragDropPreviewCardGroups export.
 */
export const getPreviewCardGroups = (): EditorPreviewCardGroup[] => {
  return cardGroups;
};

/**
 * Returns a lookup map of preview components by entry ID.
 * Results are cached after the first call.
 */
export const getPreviewComponents = (): PreviewComponents => {
  if (cachedPreviewComponents) {
    return cachedPreviewComponents;
  }

  // Flatten nested card groups and cards into a flat array of entries
  const entries = cardGroups.flatMap(group =>
    group.cards.flatMap(card => card.entries)
  );

  // Convert to a lookup map by entry ID
  cachedPreviewComponents = entries.reduce(
    (acc, entry) => {
      acc[entry.id] = entry;
      return acc;
    },
    {} as PreviewComponents
  );

  return cachedPreviewComponents;
};
